import { render } from "./startYourOrderBanner.vue?vue&type=template&id=78320348&scoped=true&ts=true"
import script from "./startYourOrderBanner.vue?vue&type=script&lang=ts"
export * from "./startYourOrderBanner.vue?vue&type=script&lang=ts"

import "./startYourOrderBanner.vue?vue&type=style&index=0&id=78320348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78320348"]])

export default __exports__